<template>
	<div>
		<b-breadcrumb>
			<b-breadcrumb-item :to="{ name: 'Categories' }">Categories</b-breadcrumb-item>
			<b-breadcrumb-item active v-if="!!error" class="text-danger"><i>Error</i></b-breadcrumb-item>
			<b-breadcrumb-item active v-else-if="loading>0" class="text-muted"><i>Loading...</i></b-breadcrumb-item>
			<b-breadcrumb-item active v-else>{{category&&category.name}}</b-breadcrumb-item>
		</b-breadcrumb>
		<b-alert :show="!!error" variant="danger">{{error}}</b-alert>
		<b-card-group v-if="!error&&category">
			<b-card no-body>
				<template #header>
					<div class="float-right">
						<b-button-group size="sm" style="margin: -10px">
							<b-button @click="$refs.editModal.show(category.id)" v-b-tooltip.hover.left title="Edit category"><b-icon icon="pencil-fill"></b-icon></b-button>
							<b-button @click="$refs.deleteModal.show(category.id)" variant="danger" v-b-tooltip.hover.right.v-danger title="Delete category"><b-icon icon="trash"></b-icon></b-button>
						</b-button-group>
					</div>
					Details
				</template>
				<b-list-group flush>
					<b-list-group-item>Name: <span class="float-right">{{category.name}}</span></b-list-group-item>
				</b-list-group>
			</b-card>
			<b-card no-body header="Mappings">
				<b-table small striped hover :items="services" :busy="loading>0" :fields="['name', 'mapping', { label: '', key: 'actions', thClass: 'text-right', tdClass: 'text-right' }]">
					<template #cell(mapping)="data">
						<VueTypeaheadBootstrap
							v-model="data.item.category_name"
							:data="data?.item?.suggestions"
							:serializer="item => item.name"
							@hit="setServiceCategory(category.id, data?.item?.id, $event.token, $event.name)"
							placeholder="Search categories..."
							@input="serviceCategorySearch(data?.item?.id, $event)"
							disable-sort
							show-all-results
							autocomplete="off"
						>
							<template slot="append">
								<b-input-group-text>
									<b-icon :icon="data?.item?.searching?'arrow-clockwise':'search'" :animation="data?.item?.searching?'spin':null"/>
								</b-input-group-text>
							</template>
							<template slot="suggestion" slot-scope="{ data }">
								<img
									v-if="data?.item?.thumbnail"
									class="rounded-circle mr-3 float-left"
									:src="data?.item?.thumbnail"
									style="width: 40px; height: 40px; float: left;"
								/>
								<div>{{data?.name||data?.token}}</div>
								<code v-if="data?.token">{{data?.token}}</code>
							</template>
						</VueTypeaheadBootstrap>
					</template>
				</b-table>
			</b-card>
		</b-card-group>
		<category-edit-modal ref="editModal" @saved="loadCategory"></category-edit-modal>
		<category-delete-modal ref="deleteModal" @deleted="loadCategory"></category-delete-modal>
	</div>
</template>

<script>
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
import CategoryEditModal from '@/components/Category/Modal/Edit.vue';
import CategoryDeleteModal from '@/components/Category/Modal/Delete.vue';

export default {
	name: 'Category',
	components: {
		VueTypeaheadBootstrap,
		CategoryEditModal,
		CategoryDeleteModal,
	},
	data() { return {
		loading: 0,
		error: null,
		category: null,
		services: null,
		serviceCategories: null,
		serviceCategorySuggestionError: null,
		serviceCategorySuggestionLoading: 0,
	}},
	created() {
		this.loadCategory();
	},
	methods: {
		async loadCategory() {
			try {
				this.loading++;
				this.category = null;
				this.category = await this.$api.get(`category/${encodeURIComponent(this.$route.params.id)}`);
				this.serviceCategories = await this.$api.get(`category/${encodeURIComponent(this.$route.params.id)}/serviceCategories`);
				this.services = (await this.$api.get(`services`)).map(s => {
					const sc = this.serviceCategories.find(c => c.service_id == s.id);
					s.category_token = sc?.category_token || null;
					s.category_name = sc?.service_category_name || '';
					s.suggestions = [];
					return s;
				});
			} catch(e) {
				this.error = e;
			} finally {
				this.loading--;
			}
		},
		async serviceCategorySearch(service_id, q) {
			try {
				this.serviceCategorySuggestionLoading++;
				const serviceIdx = this.services.findIndex(s => s.id == service_id);
				if(serviceIdx >= 0) this.services[serviceIdx].suggestions = await this.$api.get(`service/${encodeURIComponent(service_id)}/categories`, { q });
			} catch(e) {
				this.serviceCategorySuggestionError = e;
			} finally {
				this.serviceCategorySuggestionLoading--;
			}
		},
		async setServiceCategory(category_id, service_id, token, name) {
			this.$api.post(`category/${encodeURIComponent(category_id)}/service/${encodeURIComponent(service_id)}/serviceCategory`, {
				token,
				name,
			});
		},
	}
};
</script>
